import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';
import { artists, categories, genres, eventTypes } from '@/mocks/artists-directory';
import SearchBar from './components/SearchBar';
import ArtistFilterBar from './components/ArtistFilterBar';
import ArtistGrid from './components/ArtistGrid';

export default function ArtistsDirectory() {
  const { t } = useTranslation('artists');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        {/* Header */}
        <section className="w-full bg-gray-50 pt-28 md:pt-32 pb-8 md:pb-12 px-6 md:px-10 lg:px-16">
          <div className="max-w-4xl">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-3">
              {t('pageTitle')}
            </h1>
            <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-6 md:mb-8">
              {t('pageSubtitle')}
            </p>
            <SearchBar />
          </div>
        </section>

        {/* Filters */}
        <section className="w-full py-4 md:py-6 px-6 md:px-10 lg:px-16 bg-white border-b border-gray-100">
          <ArtistFilterBar
            categories={categories}
            genres={genres}
            eventTypes={eventTypes}
          />
        </section>

        {/* Grid */}
        <section className="w-full py-8 md:py-12 px-6 md:px-10 lg:px-16 bg-white">
          <ArtistGrid artists={artists} />
        </section>
      </main>
      <Footer />
    </div>
  );
}